import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Chip, Skeleton, Avatar } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const formatCurrency = (v) => v ? `R$ ${parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '-';

const HistoryPage = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0);
    const rowsPerPage = 20;
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        api.get(`/search/history?page=${page + 1}&limit=${rowsPerPage}`)
            .then(r => { setHistory(r.data.data || []); setTotal(r.data.pagination?.total || 0); })
            .finally(() => setLoading(false));
    }, [page]);

    return (
        <Box>
            <Typography variant="h4" fontWeight={700} mb={0.5}>Histórico de Pesquisas</Typography>
            <Typography color="text.secondary" mb={3}>Todas as pesquisas realizadas pela sua organização</Typography>

            <Card>
                <CardContent sx={{ p: 0 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Item Pesquisado</TableCell>
                                <TableCell>Tipo</TableCell>
                                <TableCell align="center">Cotações</TableCell>
                                <TableCell align="right">Média</TableCell>
                                <TableCell align="right">Preço de Referência</TableCell>
                                <TableCell>Fontes</TableCell>
                                <TableCell>Realizado por</TableCell>
                                <TableCell>Data</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? Array.from({ length: 8 }).map((_, i) => (
                                <TableRow key={i}>
                                    {Array.from({ length: 8 }).map((__, j) => <TableCell key={j}><Skeleton /></TableCell>)}
                                </TableRow>
                            )) : history.map(h => (
                                <TableRow key={h._id} hover sx={{ cursor: 'pointer' }}
                                    onClick={() => navigate(`/resultados?query=${encodeURIComponent(h.query)}&itemType=${h.itemType}`)}>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Avatar sx={{ bgcolor: '#eef2fa', width: 32, height: 32 }}>
                                                <SearchIcon sx={{ color: '#074960', fontSize: 16 }} />
                                            </Avatar>
                                            <Typography variant="body2" fontWeight={600}>{h.query}</Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell><Chip label={h.itemType === 'service' ? 'Serviço' : 'Material'} size="small" variant="outlined" /></TableCell>
                                    <TableCell align="center">{h.stats?.count || 0}</TableCell>
                                    <TableCell align="right">{formatCurrency(h.stats?.mean)}</TableCell>
                                    <TableCell align="right"><Typography color="primary" fontWeight={700}>{formatCurrency(h.stats?.referencePrice)}</Typography></TableCell>
                                    <TableCell>{(h.sources || []).map(s => <Chip key={s} label={s} size="small" variant="outlined" sx={{ mr: 0.5 }} />)}</TableCell>
                                    <TableCell>{h.user?.name || '-'}</TableCell>
                                    <TableCell>{new Date(h.createdAt).toLocaleDateString('pt-BR')}</TableCell>
                                </TableRow>
                            ))}
                            {!loading && history.length === 0 && (
                                <TableRow><TableCell colSpan={8} align="center" sx={{ py: 6, color: 'text.secondary' }}>Nenhuma pesquisa realizada ainda</TableCell></TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination component="div" count={total} page={page} onPageChange={(_, p) => setPage(p)} rowsPerPage={rowsPerPage} rowsPerPageOptions={[20]} labelRowsPerPage="Linhas:" />
                </CardContent>
            </Card>
        </Box>
    );
};

export default HistoryPage;
